import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from "@ng-select/ng-select";

@Component({
  selector: 'app-frecuency-modal',
  styleUrl: './frecuency.component.scss',
  templateUrl: './frecuency.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatTooltipModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
  ],
})

export class FrecuencyModalComponent {
  formData: FormGroup;
  daysList: { day: string; value: number }[] = [
    { day: 'LUNES', value: 1 },
    { day: 'MARTES', value: 2 },
    { day: 'MIÉRCOLES', value: 3 },
    { day: 'JUEVES', value: 4 },
    { day: 'VIERNES', value: 5 },
    { day: 'SÁBADO', value: 6 },
    { day: 'DOMINGO', value: 7 }
  ];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<FrecuencyModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Optional: if you want to pass data
  ) { 
    this.formData = this.fb.group({
      days: [[], [Validators.required]],
    });
  }

  ngAfterViewInit(): void {
    this.initUpdateForm();
  }

  initUpdateForm(){
    this.formData.setValue({
      days: this.data.days ? this.data.days: [null],
    })
  }
  
  save() {
    this.data.days = this.formData.value.days;
    const dataToSend = Object.entries(this.data)
    .reduce((acc, [key, value]) => {
      if (value !== '' && !(Array.isArray(value) && value.length === 0)) { 
        acc[key] = value;
      }
      return acc;
    }, {});
    this.dialogRef.close(dataToSend);
  }
}